import { render, staticRenderFns } from "./add-patient.vue?vue&type=template&id=7ed505de&scoped=true&"
import script from "./add-patient.vue?vue&type=script&lang=js&"
export * from "./add-patient.vue?vue&type=script&lang=js&"
import style0 from "./add-patient.vue?vue&type=style&index=0&id=7ed505de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed505de",
  null
  
)

export default component.exports